export const REGIONS_FIELDS = {
  CITY: 'city',
  STATE: 'state',
  TITLE: 'Inclusão de região de atendimento',
}
